import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { UiKitContext } from '../../internal/context';
/**
 * Провайдер для переопределения свойств React-контекста Ui-Kit
 */
export function UiKitContextProvider(_ref) {
  var children = _ref.children,
    propsContext = _objectWithoutProperties(_ref, _excluded);
  var currentContext = React.useContext(UiKitContext);
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  var nextContext = _objectSpread(_objectSpread({}, currentContext), propsContext);
  return /*#__PURE__*/React.createElement(UiKitContext.Provider, {
    value: nextContext
  }, children);
}